/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtpRequestDto } from '../../models/otp-request-dto';
import { ResetPasswordInitDto } from '../../models/reset-password-init-dto';

export interface Init$Params {
      body: ResetPasswordInitDto
}

export function init(http: HttpClient, rootUrl: string, params: Init$Params, context?: HttpContext): Observable<StrictHttpResponse<OtpRequestDto>> {
  const rb = new RequestBuilder(rootUrl, init.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OtpRequestDto>;
    })
  );
}

init.PATH = '/api/v1/auth/reset-password/init';
